module.exports = __webpack_public_path__ + "static/img/waiting.92272753.svg";